import CustomOnePageCheckoutDeliveryMethodState from "@crescentParts/Store/Data/CustomOnePageCheckoutDeliveryMethod/CustomOnePageCheckoutDeliveryMethodState";
import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";

import { Draft } from "immer";

const initialState = {
    requestDeliveryDateError: "",
    requestPickUpDateError: ""
};

const reducer = {
    "Custom/CustomOnePageCheckoutDeliveryMethod/setDateError":(draft:Draft<CustomOnePageCheckoutDeliveryMethodState>, action:{ requestDeliveryDateError: string, requestPickUpDateError : string },)=>{
        draft.requestDeliveryDateError = action.requestDeliveryDateError;
        draft.requestPickUpDateError= action.requestPickUpDateError;
    },
}

export default createTypedReducerWithImmer(initialState, reducer);